<!--左侧菜单组件-->
<template>
  <v-navigation-drawer
    v-model="inputValue"
    app
    floating
    persistent
    class="Nav"
    mobile-break-point="767"
    width="130"
  >
    <div class="nav-content">
      <div v-for="(item, key) in base.menus" :key="item.title">
        <div class="children">
          <v-list-tile
            :key="key"
            :to="item.to"
            :target="item.target"
            avatar
            class="listitem"
          >
            <div :class="path == item.to ? 'active' : 'v-item-content'">
              <v-icon @click="path = item.to" class="v-item-icon">{{
                item.icon
              }}</v-icon>
              {{ item.title }}
            </div>
          </v-list-tile>
        </div>
      </div>
      <core-confirm ref="myConfirm"></core-confirm>
    </div>
  </v-navigation-drawer>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import CoreConfirm from '@/components/core/confirm.vue'
export default {
  components: {
    CoreConfirm
  },
  name: 'app',
  data() {
    return {
      title: null,
      path: ''
    }
  },
  mounted: function() {
    this.path = this.$route.path
  },
  computed: {
    ...mapState({
      base: state => state.base
    }),
    inputValue: {
      get() {
        return this.$store.state.base.drawer
      },
      set(val) {
        this.setDrawer(val)
      }
    }
  },
  methods: {
    ...mapMutations('base', ['setDrawer', 'toggleDrawer'])
  }
}
</script>
<style>
.event {
  margin-top: 72px;
}
</style>
